import { DatePicker, FormGroup } from '@ksyos/design-system';
import { getSelectedLanguage } from '@frontend/translate';
import type { OutpatientClinicTaskListFilter } from '../../types/outpatientClinicTaskListFilter';

export type DateRangeFilterProps = {
    filter: OutpatientClinicTaskListFilter;
    setFilter: (filter: OutpatientClinicTaskListFilter) => void;
};

export function DateRangeFilter({ filter, setFilter }: DateRangeFilterProps) {
    const translate = getSelectedLanguage();

    return (
        <>
            <FormGroup label={translate.common.fromCapitalized}>
                <DatePicker
                    onChange={(date) => setFilter({ ...filter, startDate: date ?? undefined })}
                    value={filter.startDate ?? null}
                />
            </FormGroup>
            <FormGroup label={translate.common.toCapitalized}>
                <DatePicker
                    onChange={(date) => setFilter({ ...filter, endDate: date ?? undefined })}
                    value={filter.endDate ?? null}
                />
            </FormGroup>
        </>
    );
}
